<template>
  <div class="yx-wid">
    <div class="yx-wid banner" v-if="banners && banners.length">
      <img
        v-lazy="item.imgUrl"
        v-for="(item, index) in banners"
        :key="index"
        @click="openBanner(item)"
        :class="{ hover: index === bannerInd }"
      />
      <!-- 快捷banner导航 -->
      <div class="banner-nav">
        <span
          v-for="(item, index) in banners"
          :key="index"
          :class="{ hover: index === bannerInd }"
          @click="tabBanner(item, index)"
        ></span>
      </div>
      <!-- 左右切换 -->
      <div class="banner-prev" @click="tabPrev"></div>
      <div class="banner-next" @click="tabNext"></div>
    </div>
    <!-- 跑马灯 -->
    <div class="yx-wid-12 home-ad">
      <div class="home-ad-icon"></div>
      <div
        class="home-ad-scroll"
        v-if="newsList && newsList.length"
        ref="scorll"
      >
        <div
          class="home-ad-text"
          @mouseout="scrollStar"
          @mouseover="moveScroll"
          ref="scorllWid"
          :style="{
            transform: 'translateX(' + scorllLeftVal + 'px)',
            transition: scrollLeftStar,
          }"
        >
          <div
            class="row"
            v-for="(item, index) in newsList"
            @click="openMessage(item)"
            :key="index"
            v-html="item.scrollContent"
          ></div>
        </div>
      </div>
      <div class="home-ad-more" @click="isLoginTip(viewMessage)">
        {{ $t("more") }}
      </div>
    </div>
    <!-- 马德里竞技俱乐部ad -->
    <div class="yx-wid-12 home-ad-img">
      <img
        :src="item.img"
        v-for="(item, index) in blues"
        :key="index"
        @click="$router.push(item.link)"
      />
    </div>
    <!-- APP下载 -->
    <div class="yx-wid-12 home-load">
      <div class="home-title">
        <img src="@/assets/pic/title01.png" />
      </div>
      <div class="home-load-flex">
        <div class="flex-left">
          <img
            v-if="baseInfo && baseInfo[41].configKey"
            :src="baseText('webAppLeftImg')"
            class="img"
          />
        </div>
        <div class="flex-right" v-if="baseInfo && baseInfo[22]">
          <div class="load-tab">
            <ul>
              <li
                v-for="(item, index) in loads"
                :key="index"
                @click="loadTab(item, index)"
                :class="{ hover: index === loadInd }"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="load-sec">
            <p v-html="$t(loads[loadInd].sec)"></p>
          </div>
          <div class="load-add" v-show="[0].includes(loadInd)">
            <div class="load-add-code">
              <div class="img-box">
                <QRCode
                  v-if="baseInfo[22].configValue"
                  :text="baseText('iosApp')"
                  :width="120"
                  :height="120"
                />
              </div>
              <div class="text">
                <span>{{ $t("download.sm") }}</span>
                <p>{{ $t("download.zc") }}iOS</p>
              </div>
            </div>
            <div class="load-add-web">
              <div class="add">
                <a :href="baseText('iosApp')">{{ baseText("iosApp") }}</a>
              </div>
              <div class="text">
                <span>{{ $t("download.zjfw") }}</span>
                <p>{{ $t("download.zjfw-tips") }}</p>
              </div>
            </div>
          </div>
          <div
            class="load-add"
            v-show="[1].includes(loadInd) && baseInfo && baseInfo[21]"
          >
            <div class="load-add-code">
              <div class="img-box">
                <QRCode
                  v-if="baseInfo[21].configValue"
                  :text="baseText('androidApp')"
                  :width="120"
                  :height="120"
                />
              </div>
              <div class="text">
                <span>{{ $t("download.sm") }}</span>
                <p>{{ $t("download.zc") }}andriod</p>
              </div>
            </div>
            <div class="load-add-web">
              <div class="add">
                <a :href="baseText('androidApp')">{{
                  baseText("androidApp")
                }}</a>
              </div>
              <div class="text">
                <span>{{ $t("download.zjfw") }}</span>
                <p>{{ $t("download.zjfw-tips") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 热门游戏 -->
    <div class="yx-wid-12" v-if="initGameList && initGameList.length">
      <div class="home-title">
        <img src="@/assets/pic/title02.png" />
      </div>
      <div class="ml-game">
        <div
          class="ml-game-row"
          v-for="(item, index) in initGameList"
          :key="index"
          :class="{ hover: index === hotsGameInd }"
          @click="hotsGameInd = index"
        >
          <div class="nav" :class="{ active: index === hotsGameInd }">
            <img
              class="mr"
              :src="require('@/assets/pic/game0' + item.gameType + '.png')"
            />
            <img
              class="xz"
              :src="require('@/assets/pic/game0' + item.gameType + '-1.png')"
            />
          </div>
          <div class="nav-main">
            <div class="left">
              <h3>{{ item.gameTypeName }}</h3>
              <p>{{ item.gameDescription }}</p>
              <ul>
                <li
                  v-for="(row, rowIndex) in (item.list || []).slice(0, 14)"
                  :key="rowIndex"
                  @click="openGame(row)"
                >
                  <span> <img :src="row.icon" class="xz" /></span>
                  <p>{{ row.apiTitle }}</p>
                </li>
                <li
                  v-if="item.list && item.list.length > 14"
                  @click="$router.push(item.link)"
                >
                  <span>+</span>
                  <p>{{ $t("more") }}</p>
                </li>
              </ul>
            </div>
            <div class="right">
              <img :src="item.imageUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 优质服务 -->
    <div class="yx-wid-12 home-yz">
      <div class="home-title">
        <img src="@/assets/pic/title03.png" />
      </div>
      <div class="home-service">
        <ul>
          <li v-for="(item, index) in canvasList" :key="index">
            <div class="icon">
              <div class="gaizi"></div>
              <canvas-circle
                :id="index"
                :percent="item.ratio"
                :en="item.sec"
              ></canvas-circle>
              <span class="unit">{{ $t(item.unit) }}</span>
            </div>
            <span class="title">{{ $t(item.name) }}</span>
          </li>
        </ul>
      </div>
      <div class="home-service-list">
        <div class="row">
          <img src="@/assets/pic/icon_s_01.png" />
          <span>{{ $t("yzfw.jscqzk") }}</span>
          <p>
            {{ $t("yzfw.jscqzk-sec") }}
          </p>
        </div>

        <div class="row">
          <img src="@/assets/pic/icon_s_02.png" />
          <span>
            <span>{{ $t("yzfw.hlsszl") }}</span></span
          >
          <p>
            {{ $t("yzfw.hlsszl-sec") }}
          </p>
        </div>

        <div class="row">
          <img src="@/assets/pic/icon_s_03.png" />
          <span>{{ $t("yzfw.jsaqgl") }}</span>
          <p>
            {{ $t("yzfw.jsaqgl-sec") }}
          </p>
        </div>

        <div class="row">
          <img src="@/assets/pic/icon_s_04.png" />
          <span> {{ $t("yzfw.sdrnxz") }}</span>
          <p>
            {{ $t("yzfw.sdrnxz-sec") }}
          </p>
        </div>
      </div>
    </div>
    <Notice v-if="notice" @close="notice = false" />
    <Bulletin
      v-if="ismsgShow && newsList"
      :visible.sync="ismsgShow"
      :listData="newsList"
    />
  </div>
</template>

<script>
import Notice from "@/views/notice.vue";
import CanvasCircle from "@/components/Canvas.vue";
import QRCode from "@/components/QRCode.vue";
import Bulletin from "@/components/Bulletin.vue";
import { mapState } from "vuex";
export default {
  components: { CanvasCircle, QRCode, Notice, Bulletin },
  name: "Home",
  data() {
    return {
      ismsgShow: false,
      blues: [
        {
          img: require("@/assets/pic/blue01.png"),
          link: "/sponsor/index?type=1",
        },
        {
          img: require("@/assets/pic/blue02.png"),
          link: "/sponsor/index?type=2",
        },
        {
          img: require("@/assets/pic/blue03.png"),
          link: "/sponsor/index?type=3",
        },
        {
          img: require("@/assets/pic/blue04.png"),
          link: "/sponsor/index?type=4",
        },
        {
          img: require("@/assets/pic/blue05.png"),
          link: "/sponsor/index?type=5",
        },
        {
          img: require("@/assets/pic/blue06.png"),
          link: "/sponsor/index?type=6",
        },
      ],
      canvasList: [
        {
          ratio: 60,
          name: "yzfw.pjcksj",
          unit: "yzfw.m",
        },
        {
          ratio: 80,
          name: "yzfw.hzzfpt",
          unit: "yzfw.j",
        },
        {
          ratio: 90,
          name: "yzfw.pjqksj",
          unit: "yzfw.m",
        },
        {
          ratio: 27,
          name: "yzfw.hzyxpt",
          unit: "yzfw.j",
        },
      ],
      bannerInd: 0,
      bannerTimer: null,
      loads: [
        {
          name: "IOS APP",
          title: "iOS APP",
          type: 1,
          sec: "views.index.078930-0",
          img: require("@/assets/images/ad01.png"),
          link: "",
        },
        {
          name: "Andriod APP",
          title: "andriod APP",
          type: 2,
          sec: "views.index.078930-1",
          img: require("@/assets/images/ad02.png"),
          link: "",
        },
      ],
      loadInd: 0,
      hotsGameInd: 0,
      newsList: null,
      banners: null,
      canvas: null,
      context: null,
      flash: 0.1,
      scorllLeftVal: 0,
      scrollLeftStar: "all .4s",
      timerText: null,
      scorllWid: 0,
      isScroll: false,
      notice: false,
    };
  },
  computed: {
    initGameList() {
      let arr = [];
      if (this.navsList && this.navsList.length) {
        arr = this.navsList.filter((item) => item.gameType);
      }
      console.log(arr);

      return arr;
    },
    ...mapState([
      "navsVal",
      "navsList",
      "isLogin",
      "baseInfo",
      "hotsGameList",
      "userInfo",
    ]),
  },
  watch: {
    baseInfo(val) {
      if (val && val.length) {
        this.initBaseInfo();
      }
    },
    // userInfo(val) { //个人信息未填写
    //   if (val) {
    //     this.checkName();
    //   }
    // },
  },
  mounted() {
    this.getTop50MessageList();
    this.getSilde();

    // this.isShow21()
    // this.checkName();//个人信息未填写
  },
  methods: {
    // 检测是否设置姓名
    checkName() {
      if (this.isLogin && this.userInfo && !this.userInfo.realName) {
        this.$confirm(
          this.$t("views.index.078930-2"),
          this.$t("views.index.078930-3"),
          {
            confirmButtonText: this.$t("views.index.078930-4"),
            cancelButtonText: this.$t("views.index.078930-5"),
            type: "none",
          }
        )
          .then(() => {
            this.$router.push("/mine/userInfo");
          })
          .catch(() => {
            console.log(this.$t("views.index.078930-5"));
          });
      }
    },
    // 是否显示21周岁
    isShow21() {
      const dayOld = localStorage.getItem("notice");
      const time = Date.parse(new Date()); //获取当天时间
      const TimeDays = 1000 * 60 * 60 * 24; //设定1天时间
      const isDayTime = time - Number(dayOld); //计算时间
      if (dayOld) {
        this.notice = false;
        if (isDayTime >= TimeDays) {
          localStorage.removeItem("notice", time);
          this.notice = true;
        }
      } else {
        localStorage.setItem("notice", time);
        this.notice = true;
      }
    },

    // 基础信息赋值给data上
    initBaseInfo() {
      if (!this.baseInfo) return;
      this.loads.forEach((item) => {
        if (item.type === 1) {
          item.link = this.baseInfo.find(
            (item) => item.configKey === "androidApp"
          ).configValue;
        }
        if (item.type === 2) {
          item.link = this.baseInfo.find(
            (item) => item.configKey === "iosApp"
          ).configValue;
        }
      });
    },

    viewMessage() {
      this.$router.push("/mail");
    },
    openMessage(val) {
      this.$confirm(val.content, val.title, {
        confirmButtonText: this.$t("views.index.078930-6"),
        customClass: "el-pop-wid-message",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          if (!this.isLogin) return;
          this.$router.push("/mail");
        })
        .catch(() => {
          console.log(11);
        });
    },
    // banner
    getSilde() {
      const params = {
        position: 1,
        device: 1,
      };
      this.$Api.getSilde(params).then((res) => {
        if (res) {
          this.banners = res.slideList;
          this.autoBanner();
        }
      });
    },
    // 公告
    getTop50MessageList() {
      this.$Api.getTop50MessageList().then((res) => {
        if (res) {
          this.newsList = res.messageList;
          if (this.newsList && this.newsList.length) {
            // 设定24小时后重新开启公告通知弹窗
            const isDay = localStorage.getItem("messageAuto");
            if (!isDay && this.newsList.length) {
              this.ismsgShow = true;
            }
            if (isDay) {
              const targetDay = 24 * 60 * 60 * 1000; //一天秒数
              const isDYDay = new Date().getTime() - isDay; //获取当前日期是否超过一天
              if (isDYDay > targetDay) {
                localStorage.removeItem("messageAuto");
              }
            }
          }
          this.$nextTick(() => {
            this.scrollInit();
          });
        }
      });
    },
    moveScroll() {
      clearInterval(this.timerText);
    },
    // 跑马灯初始化
    scrollInit() {
      // 获取box宽度
      const dowSocrll = this.$refs.scorll.clientWidth;
      this.scorllWid = this.$refs.scorllWid.clientWidth;
      const domClone = this.$refs.scorllWid;
      this.isScroll = this.scorllWid > dowSocrll ? true : false;
      if (this.isScroll) {
        let dom = domClone.cloneNode(true);
        domClone.appendChild(dom);
        this.scrollStar();
      }
    },
    scrollStar() {
      if (!this.isScroll) return;
      this.timerText = setInterval(() => {
        const valNumber = 5;
        this.scorllLeftVal -= valNumber;
        if (this.scorllLeftVal <= -this.scorllWid) {
          this.scorllLeftVal = 0;
          this.scrollLeftStar = "none";
          setTimeout(() => {
            this.scrollLeftStar = "all .4s";
          }, 50);
        }
      }, 120);
    },
    tabLive(val, index) {
      this.liveInd = index;
    },
    TabHotsGame(val, index) {
      this.hotsGameInd = index;
    },
    autoBanner() {
      this.bannerTimer = setInterval(() => {
        this.bannerInd++;
        if (this.bannerInd >= this.banners.length) {
          this.bannerInd = 0;
        }
      }, 5000);
    },
    tabBanner(val, index) {
      clearInterval(this.bannerTimer);
      this.bannerInd = index;
      this.autoBanner();
    },
    openBanner(val) {
      if (val.activityId != null) {
        this.$router.push("/activity/activityLandPage?type=" + val.activityId);
      }
    },
    tabPrev() {
      clearInterval(this.bannerTimer);
      if (this.bannerInd === 0) {
        this.bannerInd = this.banners.length;
      }
      this.bannerInd--;
      this.autoBanner();
    },
    tabNext() {
      clearInterval(this.bannerTimer);
      this.bannerInd++;
      if (this.bannerInd === this.banners.length) {
        this.bannerInd = 0;
      }
      this.autoBanner();
    },
    loadTab(val, index) {
      this.loadInd = index;
    },
    // 打开游戏
    openGame(val) {
      if (val.gameType === 2) {
        this.$router.push({
          path: "/game/egame",
          query: {
            code: val.platType,
          },
        });
        this.isShowSelect = false;
        return;
      }
      if (val.gameType === 6) {
        this.$router.push({
          path: "/game/fishing",
          query: {
            code: val.platType,
          },
        });
        this.isShowSelect = false;
        return;
      }
      if (!this.isLogin) {
        this.$confirm(
          this.$t("views.index.078930-7"),
          this.$t("views.index.078930-3"),
          {
            confirmButtonText: this.$t("views.index.078930-4"),
            showCancelButton: false,
            customClass: "el-pop-wid",
          }
        )
          .then(() => {
            this.$router.push("/user/login");
          })
          .catch(() => {
            console.log(11);
          });
        return;
      }

      const params = {
        platType: val.platType,
        gameType: val.gameType,
        gameCode: val.gameCode,
        devices: 0,
      };
      this.$Api.getGameUrl(params).then((res) => {
        if (res) {
          const url = JSON.parse(res.data);
          window.open(url.url, "_blank");
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.moveScroll);
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 700px;
  position: relative;
  overflow: hidden;

  &:hover {
    .banner-next,
    .banner-prev {
      display: block;
    }
  }

  img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%) scale(0.85);
    top: 0;
    height: 100%;
    opacity: 0;
    transition: all 0.8s;

    &.hover {
      opacity: 1;
      transform: translateX(-50%) scale(1);
      z-index: 1;
    }
  }

  &-nav {
    white-space: nowrap;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;

    span {
      width: 16px;
      height: 16px;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      margin: 0 3px;

      &::before,
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 100%;
      }

      &::before {
        width: 50%;
        height: 50%;
        background: linear-gradient(-35deg, #4f89e5, #81b1ff);
        display: block;
      }

      &.hover {
        &::before {
          background: linear-gradient(-35deg, #4f89e5, #81b1ff);
        }

        &::after {
          width: 70%;
          height: 70%;
          border: 1px solid var(--theme);
        }
      }
    }
  }
}

.banner-prev,
.banner-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 80px;
  background: rgba(121, 129, 164, 0.5);
  border-radius: 0 5px 5px 0;
  z-index: 2;
  display: none;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border: 2px solid transparent;
    border-left-color: white;
    border-top-color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    background: rgba(121, 129, 164, 1);
  }
}

.banner-next {
  right: 0;
  border-radius: 5px 0 0 5px;

  &::before {
    transform: translate(-50%, -50%) rotate(135deg);
  }
}

.home-ad {
  display: flex;
  align-items: center;
  padding: 10px 30px 60px;
  margin-top: 31px;
  background: url("@/assets/pic/add-bg.png") no-repeat;
  background-size: 100% auto;
  gap: 10px;

  &-icon {
    width: 24px;
    height: 24px;
    background: url("@/assets/pic/add.png") no-repeat center center;
    background-size: cover;
  }

  &-scroll {
    flex: 1;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    color: #788b9d;
    position: relative;
  }

  &-text {
    display: inline-block;
    white-space: nowrap;
    // width: 100%;
    // animation: amin 10s linear infinite;

    .row {
      display: inline-block;
      vertical-align: middle;
      margin-right: 60px;
      cursor: pointer;
      color: var(--main-color);
    }
  }

  &-more {
    min-width: 44px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    border: 1px solid var(--theme);
    border-radius: 13px;
    color: var(--theme);
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: var(--theme);
      color: white;
    }
  }

  &-img {
    margin-top: 36px;
    cursor: pointer;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;

    img {
      transition: all 0.2s;
      width: 100%;

      &:hover {
        transform: scale(1.08);
      }
    }
  }
}

// @keyframes amin {
//   0% {
//     transform: translateX(0);
//   }

//   100% {
//     transform: translateX(-100%);
//   }
// }

.home-title {
  width: 100%;
  margin: 80px auto 50px;
  height: 34px;
  text-align: center;

  img {
    height: 100%;
  }
}

.home-load-flex {
  display: flex;
  align-items: center;
  gap: 50px;

  .img {
    width: 880px;
  }

  .flex-left {
    flex: 1;

    .img {
      width: 115%;
      margin-left: -15%;
    }
  }

  .flex-right {
    width: 456px;
    height: 500px;
    flex: none;
    display: flex;
    flex-direction: column;
    gap: 40px;

    .load-tab {
      ul {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      li {
        width: 123px;
        height: 40px;
        background: url("@/assets/pic/btn-bg01.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--color-main);
        font-size: 16px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }

        &.hover {
          color: white;
          background: url("@/assets/pic/btn-bg02.png") no-repeat;
          background-size: 100% 100%;
          &.hover {
            opacity: 1;
          }
        }
      }
    }

    .load-sec {
      padding: 0 10px;

      p {
        line-height: 34px;
        font-size: 16px;
        text-align: justify;
        color: var(--color-main);
      }
    }

    .load-add {
      display: flex;
      padding: 0 10px;
      gap: 60px;

      &-code,
      &-web {
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        .img-box,
        .add {
          background: url("@/assets/pic/load_code_bg.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 18px;
          box-shadow: 0 5px 10px 0 rgba(128, 198, 255, 0.25);
          padding: 25px 10px;
          width: 162px;
          height: 180px;
          flex: none;
          display: flex;
          justify-content: center;
        }

        .text {
          text-align: center;
          line-height: 22px;
          color: var(--color-main);

          span {
            font-size: 14px;
            margin-top: 16px;
            display: block;
            font-weight: bold;
          }

          p {
            font-size: 12px;
            white-space: normal;
            word-break: break-all;
          }
        }
      }

      &-web {
        .add {
          a {
            color: var(--theme);
            word-wrap: break-word;
          }
        }
      }

      &-code {
        .img {
          width: 120px;
        }
      }
    }
  }
}

.load-add-pc {
  padding: 0 10px;
  margin-top: 32px;

  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  li {
    width: 120px;
    height: 168px;
    background: #f0f6ff;
    border: 1px solid #fff;
    box-sizing: border-box;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 60%;
    }

    .btn {
      background: url("@/assets/images/tab-bg1.png") no-repeat;
      line-height: 22px;
      height: 22px;
      width: 68px;
      font-size: 12px;
      background-size: 100% 100%;
      cursor: pointer;
      box-shadow: 0 2px 5px #5da7eb;
      border-radius: 11px;
      color: white;
      text-align: center;
      margin-top: 12px;
    }
  }
}

.live-scroll {
  margin-top: 16px;
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 144px;

  &-list {
    white-space: nowrap;
    width: 100%;
  }

  &-box {
    display: inline-block;
    vertical-align: middle;
    width: 320px;
    height: 112px;
    margin-right: 16px;
    filter: drop-shadow(0 8px 20px rgba(204, 221, 219, 0.4));
  }

  &-row {
    width: 320px;
    height: 112px;
    box-sizing: border-box;
    cursor: pointer;
    background: #e9eff8;
    border-radius: 12px;
    background: #fff;
    border: 2px solid #fff;
    padding: 44px 16px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &:hover {
      border: 2px solid var(--theme);
    }

    &.hover {
      background: #f0f6ff;
      border: 2px solid var(--theme);

      &::before {
        content: "";
        position: absolute;
        border: 8px solid transparent;
        border-top-color: var(--theme);
        border-bottom: none;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .live-row-title {
      position: absolute;
      top: 10px;
      left: 0;
      right: 0;
      text-align: center;
      height: 20px;
      line-height: 20px;
      font-weight: 500;
      justify-content: center;
      padding: 0;
      margin-bottom: 8px;
      color: #30383f;
    }

    .left,
    .right {
      text-align: center;

      .img {
        flex: 0 0 44px;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);

        img {
          width: 84%;
        }
      }
    }

    .center {
      padding: 0 30px;
      text-align: center;

      .vs {
        display: flex;
        height: 24px;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 5px;
        text-overflow: -5px;
      }

      .text {
        font-size: 12px;
      }

      .vs-open {
        display: flex;
        align-items: center;
        justify-content: center;

        .vs-row {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 24px;
          height: 24px;
          margin: 0 3px;

          &.one {
            background-image: url("@/assets/images/game-icon-01.png");
          }

          &.two {
            background-image: url("@/assets/images/game-icon-03.png");
          }

          &:hover {
            &.one {
              background-image: url("@/assets/images/game-icon-02.png");
            }

            &.two {
              background-image: url("@/assets/images/game-icon-04.png");
            }
          }
        }
      }
    }
  }
}

.live-video {
  display: flex;
  align-items: center;

  &-left {
    height: 650px;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 24px;
  }

  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: white;
    padding: 12px 0;

    .name {
      color: #30383f;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;

      .logo {
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 6px solid #d3ebfe;
        background: white;
        border-radius: 100%;
        margin: 0 8px;
      }
    }

    .vs-number {
      font-size: 36px;
      letter-spacing: 5px;
      color: #30383f;
      font-weight: bold;
      margin: 0 10px;
    }
  }

  &-right {
    width: 308px;
    display: flex;
    flex-direction: column;
    height: 650px;
    background: #f1f3f5;
    border-radius: 12px;
    border: 1px solid #fff;

    .chat-list {
      flex: 1;
      position: relative;
      overflow: hidden;

      &-no {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .chat-send {
      background: white;
      display: flex;
      align-items: center;
      padding: 12px;

      .send {
        background: #f1f3f5;
        border: 1.5px solid #fff;
        height: 36px;
        line-height: 1;
        border-radius: 12px;
        background-image: url("@/assets/images/fj.png");
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: 250px center;
        padding: 8px 36px 8px 8px;
        font-size: 12px;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        flex: 1;
      }
    }
  }
}

.live-video-data {
  display: flex;
  align-items: flex-end;
  background: white;
  border-radius: 12px;
  padding: 10px 24px;
  margin-top: 20px;

  .left {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .data-row {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }

    &-title {
      font-size: 12px;
      border-bottom: 1px solid #e4eaff;
      color: #30383f;
    }

    &-list {
      display: flex;
      align-items: center;
      margin-top: 4px;

      li {
        flex: 1;
        height: 44px;
        padding: 4px 0;
        background: #fff;
        border: 1px solid #ebedf0;
        box-sizing: border-box;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 12px;

        &:last-child {
          margin-right: 0;
        }

        span {
          color: #788b9d;
          font-size: 12px;
        }

        p {
          color: #4ab06a;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;

          em {
            border-radius: 2px;
            margin-right: 2px;
            border: 4px solid transparent;
            border-top: 6px solid #4ab06a;
            border-bottom: none;
          }

          &.red {
            color: #e95b5b;

            em {
              border: 4px solid transparent;
              border-bottom: 6px solid #e95b5b;
              border-top: none;
            }
          }
        }
      }
    }
  }

  .right {
    margin-left: 30px;
  }
}

.live-video-play {
  flex: 1;
  background: #30383f;
  border-radius: 12px;
  margin-top: 24px;
}

.home-service {
  ul {
    display: flex;
    align-items: center;
  }

  li {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;

    .icon {
      position: relative;
      width: 190px;
      height: 190px;
      margin: 7px auto 0;
      background: url("@/assets/pic/load_number.png") no-repeat center;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      .gaizi {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url("@/assets/pic/load_number1.png") no-repeat center;
        background-size: 90%;
      }
    }

    .title {
      margin-top: 16px;
      margin-bottom: 2px;
      font-size: 18px;
      font-weight: 500;
      color: var(--color-main);
      line-height: 25px;
    }

    .sec {
      line-height: 15px;
      font-size: 12px;
      color: #788b9d;
      font-weight: 400;
    }

    .unit {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      color: var(--color-main);
      font-size: 16px;
    }
  }
}

.home-service-list {
  margin-top: 24px;
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  .row {
    position: relative;
    background: url("@/assets/pic/icon_s_bg.png") no-repeat center top;
    background-size: 100% 100%;
    padding: 24px 30px;
    height: 386px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;

    img {
      width: 88px;
    }

    span {
      font-weight: 500;
      font-size: 22px;
      color: var(--color-main);
      line-height: 25px;
    }

    p {
      font-weight: 400;
      line-height: 22px;
      font-size: 14px;
      color: var(--color-main);
    }
  }
}

.home-yz {
  margin-top: 88px;
}
.ml-game {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  gap: 3px;
  &-row {
    position: relative;
    overflow: hidden;
    animation: moveBoxClose 0.7s ease-out forwards;
    &.hover {
      animation: moveBox 0.7s ease-out forwards;
    }
    &:last-child {
      .nav-main {
        border-radius: 0 10px 10px 0;
      }
    }
  }
  .nav {
    width: 56px;
    cursor: pointer;
    .mr {
      display: none;
    }
    &.active,
    &:hover {
      .xz {
        display: none;
      }
      .mr {
        display: block;
      }
    }
    img {
      width: 100%;
    }
  }
  .nav-main {
    background: url("@/assets/pic/game_bg.png") no-repeat center;
    padding: 66px 0 0 36px;
    z-index: 1;
    position: absolute;
    left: 56px;
    top: 27px;
    width: 788px;
    height: 500px;
    display: flex;
    .left {
      display: flex;
      flex-direction: column;
      gap: 15px;
      flex: 1;
      ul {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 10px;
        li {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:hover {
            span {
              background: linear-gradient(
                0,
                var(--theme),
                #3281ff,
                var(--theme)
              );
              color: white;
              border: 1px solid var(--theme);
            }
            img {
              filter: drop-shadow(50px 50px 0 white);
            }
          }
          p {
            margin-top: 8px;
            text-align: center;
          }
          span {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(0, #fff, #f1faff, #fff);
            position: relative;
            transition: all 0.2s;
            box-shadow: 0 5px 10px rgb(230, 230, 230);
            border: 1px solid white;
            font-size: 30px;
            color: var(--theme);
            img {
              position: absolute;
              top: -15%;
              left: -15%;
              transform: translate(-100%, -100%);
              width: 80%;
              filter: drop-shadow(50px 50px 0 var(--theme));
            }
          }
        }
      }
    }
    .right {
      width: 46%;
      img {
        width: 100%;
      }
    }
    h3 {
      font-size: 36px;
      color: var(--color-theme);
    }
  }
}
@keyframes moveBox {
  0% {
    width: 56px;
  }
  100% {
    width: 844px;
  }
}
@keyframes moveBoxClose {
  0% {
    width: 844px;
  }
  100% {
    width: 56px;
  }
}
</style>
